import axios from "../axios";

// 按年级对比
export const getGradeTableEcharsList = (data) => {
  return axios({
    url: "/console/education/data_compare_grade",
    method: "GET",
    data: data,
  });
};
// 按班级对比
export const getClassTableEcharsList = (data) => {
  return axios({
    url: "/console/education/data_compare_class",
    method: "GET",
    data: data,
  });
};
// 获取全部班级列表
export const getAllClassList = (data) => {
  return axios({
    url: "/console/homework_class/list_by_grade_and_class_number",
    method: "GET",
    data: data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/dataComparison.js